import Marionette from "backbone.marionette";
import templates from "../../utils/templates";

const DEFAULTS = {
  tagName: "li",
  className: "list-group-item",
  template: templates.find("environment_selector", "item"),
};

class EnvironmentListItem extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  events() {
    return {
      click: "clicked",
    };
  }

  onBeforeRender() {
    if (this.model.getChecked()) {
      this.$el.addClass("selected");
    }
  }

  clicked(e) {
    e.preventDefault();

    this.triggerMethod("itemClicked", this.model);
  }
}

export { EnvironmentListItem as default };
